import { Message } from 'element-ui';

/**
 * 全局错误处理器
 */
export function setupErrorHandler(Vue) {
  // Vue全局错误处理
  Vue.config.errorHandler = (err, vm, info) => {
    // console.error('Vue Error:', err);
    // console.error('Error Info:', info);
    
    // 根据错误类型显示不同的提示
    let errorMessage = '应用程序出现错误';
    
    if (err.message) {
      // 网络错误
      if (err.message.includes('Network Error')) {
        errorMessage = '网络连接失败，请检查您的网络';
      } 
      // 超时错误
      else if (err.message.includes('timeout')) {
        errorMessage = '请求超时，请稍后重试';
      }
      // 其他错误
      else {
        errorMessage = err.message;
      }
    }
    
    Message({
      message: errorMessage,
      type: 'error',
      duration: 3000,
      showClose: true
    });
  };
  
  // 全局警告处理
  Vue.config.warnHandler = (msg, vm, trace) => {
    // console.warn('Vue Warning:', msg);
    // console.warn('Trace:', trace);
  };
  
  // 捕获未处理的Promise错误
  window.addEventListener('unhandledrejection', event => {
    // console.error('Unhandled Promise Rejection:', event.reason);
    
    // 阻止默认的错误提示
    event.preventDefault();
    
    let errorMessage = '操作失败';
    
    if (event.reason) {
      if (event.reason.message) {
        if (event.reason.message.includes('Network Error')) {
          errorMessage = '网络连接失败，请检查您的网络';
        } else if (event.reason.message.includes('timeout')) {
          errorMessage = '请求超时，请稍后重试';
        } else {
          errorMessage = event.reason.message;
        }
      } else if (typeof event.reason === 'string') {
        errorMessage = event.reason;
      }
    }
    
    Message({
      message: errorMessage,
      type: 'error',
      duration: 3000,
      showClose: true
    });
  });
  
  // 捕获全局错误
  window.addEventListener('error', event => {
    // console.error('Global Error:', event.error);
    
    // 忽略资源加载错误
    if (event.target !== window) {
      return;
    }
    
    Message({
      message: '应用程序出现错误，请刷新页面重试',
      type: 'error',
      duration: 3000,
      showClose: true
    });
  });
}

/**
 * 安全执行异步操作
 * @param {Function} asyncFn - 异步函数
 * @param {String} errorMsg - 错误提示信息
 */
export async function safeAsync(asyncFn, errorMsg = '操作失败') {
  try {
    return await asyncFn();
  } catch (error) {
    // console.error('Safe Async Error:', error);
    Message({
      message: error.message || errorMsg,
      type: 'error',
      duration: 3000,
      showClose: true
    });
    throw error;
  }
}
